export default {
  open: false,
  data: { url: '' },
  support: !!(global.navigator && global.navigator.share)
}
